import { useEffect, useState } from 'react'
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';

export default function AssetTypeDetail({assetTypeId, assetTypeDetailData}) {

    const assetTypeUrl          =   BACKOFFICE_BASE_URL + '/asset_type';
    const access_token          =   useSelector(state => state.auth.access_token);

    const [loading, setLoading]         =   useState(false);
    const [detailData, setDetailData]   =   useState(null);


    useEffect(() => {
        if(assetTypeId) {
            detail()
        }
    }, [assetTypeId])

    const detail    = () => {
        setLoading(true);
        HttpAPICall.withAthorization('GET', assetTypeUrl + '/detail/' + assetTypeId, access_token, {}, {}, (resp) => {
            setDetailData(resp.data);
            assetTypeDetailData(resp.data);
        }).then(() => setLoading(false));
    }   


  return (
    <section className="item_view_container bg-white">
        {
            loading 
            ? <Loader/>
            :
            <>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                        type="button" role="tab" aria-controls="details" aria-selected="true">Details
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane  show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                    <div className="tab_content_header">
                        <div className="tab_content_wrapper"> <span className="content_heading">Details</span></div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody className='resource_table'>
                                <tr>
                                    <td style={{ width: "25%" }}>Name</td>
                                    <th>{detailData?.asset_type_name}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Sections</td>
                                    <th>
                                        <ol>
                                            {detailData?.sections.map(s => (<li>{s.component}</li>))}
                                        </ol>
                                    </th>
                                </tr>
                            </tbody>
                        </table>

                        <div className="tab_content_wrapper"> <span className="content_heading">Attributes Applicable</span></div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody className='resource_table'>
                                {
                                    detailData?.attributes.map(at => (
                                        <tr key={at.key}>
                                            <td style={{ width: "25%" }}>{at.name}</td>
                                            <th>{at.value}</th>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>

                        <div className="tab_content_wrapper"> <span className="content_heading">Odo Meter Applicable</span></div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody className='resource_table'>
                                {
                                    detailData?.odo_meters.map(at => (
                                        <tr key={at.key}>
                                            <td style={{ width: "25%" }}>{at.label}</td>
                                            <th>{at.active === 'Y' ? 'Yes' : 'No'}</th>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </>
        }
    </section>
  )
}
